import Image from '../../atoms/Image';
import Text from '../../atoms/Text';
import { TableTrade } from '../../core/models/table-trade.model';

import paper from '../../assets/images/paper.svg';

import './styles.scss';

interface IStatsProps {
  data: TableTrade;
  address: string | undefined;
  chain: string;
  timezone?: string;
  date?: number;
  onShowModal: () => void;
}

const Stats = ({ data, onShowModal }: IStatsProps) => (
  <div className='stats_column'>
    <Image
      data-tip='Bot / Smart Contract'
      src={data.bot ? paper : undefined}
      size='m'
    />
    <div
      className='stats_column__icon icon-eye'
      onClick={onShowModal}
      data-tip='Show more trades with this wallet'
    />
    <Text size={10} className='info text--grey-600 text--weight-500'>
      {data.tradesNum}
    </Text>
  </div>
);
export default Stats;
